import View                      from '@widesk-ui/components/View';
import currentEditorStore        from '@/TokamapEditor/stores/currentEditorStore';
import currentProjectEditorStore from '@/TokamapEditor/stores/currentProjectEditorStore';
import Choice                    from '@/TokamapEditor/ux/AreaSidebar/Choice';
import linkMapToShape            from '@/TokamapEditor/helpers/linkMapToShape';
import { commonValue }           from '@/TokamapEditor/ux/AreaSidebar/multiSelectHelpers';
import { observer }              from 'mobx-react-lite';
import useDesignTokens           from '@/hooks/useDesignTokens';
import compareMapsByPosition     from '@/TokamapEditor/helpers/compareMapsByPosition';

const AreaMapSection = () => <AreaMapSectionContent />;

const AreaMapSectionContent = observer(() => {
	const shapes = currentEditorStore.sidebarShapes;
	const tokens = useDesignTokens();

	if (!shapes.length) return null;

	const targetMapId = commonValue(shapes, s => s.targetDocumentId);

	// La carte courante est exclue : s'y envoyer depuis elle-même ne mènerait nulle part.
	const maps = currentProjectEditorStore.get.mapCollection.models
		.filter(map => !!map.id && map.id !== currentEditorStore.map?.id)
		.sort(compareMapsByPosition);

	return (
		<View gap="sm">
			{maps.length ? (
				<>
					<View size={13} style={{ fontWeight: 600 }}>Carte de destination</View>

					<View gap="xs">
						{maps.map(map => (
							<Choice
								key={map.id}
								selected={targetMapId === map.id}
								onClick={() => linkMapToShape(shapes.map(s => s.id), map.id)}
							>
								{map.label}
							</Choice>
						))}
					</View>
				</>
			) : (
				<View color={tokens.text.muted} size={13}>
					Ce projet n'a pas d'autre carte vers laquelle emmener le visiteur. Ajoutez-en une depuis le
					menu des cartes, en haut à droite.
				</View>
			)}
		</View>
	);
});

export default AreaMapSection;
